import { ActivitiesBehavior } from 'core/type/behaviors.types';

export const getShowEarnAcceleratorBannerBehavior = (behavior: ActivitiesBehavior) => {
    return behavior?.header?.showEarnAcceleratorBanner;
};
